import React from 'react';

export const AppStateContext = React.createContext();

const isBrowser = typeof window !== 'undefined';

const localStorageKeys = {
  lang: 'ca.vabysmo.lang'
};

const getLocalStorageItem = key => {
  return isBrowser ? window.localStorage.getItem(key) : null;
};

const setLocalStorageItem = (key, value) => {
  isBrowser && window.localStorage.setItem(key, value);
};

const getDefaultLanguage = () => {
  if (isBrowser) {
    const browserLanguage = navigator.language || navigator.userLanguage;
    if (browserLanguage.startsWith('fr-')) {
      return 'french';
    }
  }

  return 'english';
};

export class AppStateProvider extends React.Component {
  constructor(props) {
    super(props);

    let language = getLocalStorageItem(localStorageKeys.lang);
    if (!language || !['english', 'french'].includes(language)) {
      language = getDefaultLanguage();
    }

    this.state = {
      language,
      page: null,
      section: null,
      mobileMenuOpen: false
    };

    this.loadLanguage(language);
  }

  setLanguage = language => {
    if (!language || !['english', 'french'].includes(language)) {
      language = 'english';
    }

    this.setState({
      language
    });

    localStorage.setItem(localStorageKeys.lang, language);
    this.loadLanguage(language);
  };

  loadLanguage = language => {
    if (isBrowser && window.OneTrust) {
      const langCode = language === 'french' ? 'fr' : 'en';
      window.OneTrust.changeLanguage(langCode);
    }
  };

  setPage = page => {
    this.setState({
      page
    });
  };

  setSection = section => {
    this.setState({
      section
    });
  };

  toggleMobileMenu = () => {
    const mobileMenuOpen = this.state.mobileMenuOpen === false ? true : false;
    this.setState({
      mobileMenuOpen
    });
  };

  closeMobileMenu = () => {
    setTimeout(() => {
      this.setState({
        mobileMenuOpen: false
      });
    }, 50);
  };

  toggleLanguage = () => {
    const language = this.state.language === 'french' ? 'english' : 'french';
    this.setState({
      language
    });
    setLocalStorageItem(localStorageKeys.lang, language);
  };

  getValue = () => {
    return {
      ...this.state,
      setPage: this.setPage,
      setLanguage: this.setLanguage,
      setSection: this.setSection,
      toggleMobileMenu: this.toggleMobileMenu,
      closeMobileMenu: this.closeMobileMenu,
      toggleLanguage: this.toggleLanguage
    };
  };

  render() {
    return <AppStateContext.Provider value={this.getValue()}>{this.props.children}</AppStateContext.Provider>;
  }
}

export function wrapRootElement({ element }) {
  return <AppStateProvider>{element}</AppStateProvider>;
}
